export class FrontLineDocReturnConfirmRequest {
  doNo: string;
  docTypes: string[];
  doLockHeader: string | null;
  applyUser: string | null;
  isAccept: boolean;
  rejectReason: string | null;

  constructor() {
    this.doNo = "";
    this.docTypes = [];
    this.doLockHeader = "";
    this.applyUser = "";
    this.isAccept = true;
    this.rejectReason = "";
  }
}
